import React, { createContext, useContext, useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/* The only place in the codebase that decides which routes are dark.
   Everything else reads the theme from <html data-theme="..."> in CSS. */
const DARK_ROUTES = [
  /^\/$/,                 // Landing - the 3D model experience
  /^\/animations(\/|$)/,  // DetailedModel - /animations/main, /animations/gym
];

const ThemeContext = createContext('light');

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const { pathname } = useLocation();
  const theme = useMemo(
    () => (DARK_ROUTES.some(route => route.test(pathname)) ? 'dark' : 'light'),
    [pathname]
  );

  /* <html> is the only common ancestor of .container AND body's own painted
     background, so the attribute has to be written imperatively.
     useLayoutEffect, not useEffect, so it lands before paint. */
  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};
